import "./App.css";
import PdfViewer from "./components/PdfViewer/PdfViewer";
import { useState, useEffect } from "react";
import { SyncLoader } from "react-spinners"; //https://www.npmjs.com/package/react-spinners
import Menu from "./components/Menu/Menu";
import Homepage from "./components/Homepage/Homepage";

function App() {
  const [translation, setTranslation] = useState(
    "Let's break down language barriers! \n\nStart by selecting the text you'd like to translate using the lasso tool."
  );
  const [loading, setLoading] = useState(false);
  const [isSelectToolActive, setIsSelectToolActive] = useState(true);
  const [currentFile, setCurrentFile] = useState("./tester.pdf");
  const [currentPage, setCurrentPage] = useState("home");
  const [pageNumber, setPageNumber] = useState(1);
  const color = "#333333";

  const handleTranslationUpdate = (newTranslation) => {
    setTranslation(newTranslation);
  };

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const changeFile = (file) => {
    setCurrentFile(file);
    setCurrentPage("pdf");
    setPageNumber(1);
  };

  const goToSample = () => {
    setCurrentFile("./tester.pdf");
    setCurrentPage("pdf");
    setPageNumber(1);
  };

  useEffect(() => {
    if (translation) {
      console.log("Translation updated:", translation);
    }
  }, [translation]);

  useEffect(() => {
    if (isSelectToolActive) {
      console.log("Select Tool Active");
    } else {
      console.log("Select Tool Not Active");
    }
  }, [isSelectToolActive]);

  if (currentPage === "home") {
    return <Homepage handleChange={changeFile} sample={goToSample} />;
  } else if (currentPage === "pdf") {
    return (
      <div class="container">
        <div className="inner-container">
          <div class="buttons">
            <Menu
              onSelectToolChange={setIsSelectToolActive}
              setCurrFileToApp={setCurrentFile}
              goHome={setCurrentPage}
              pageNumber={pageNumber} // Pass pageNumber to Menu
              setPageNumber={setPageNumber}
            />
          </div>

          <div class="pdf">
            <PdfViewer
              onTranslationUpdate={handleTranslationUpdate}
              onLoadingChange={handleLoadingChange}
              selected={isSelectToolActive}
              currFile={currentFile}
              pageNumber={pageNumber} // Pass pageNumber to PdfViewer
              setPageNumber={setPageNumber}
            />
          </div>

          <div class="translation">
            <div className="text-style">
              {!loading ? (
                <textarea
                  className="text-translation"
                  disabled
                  value={translation}
                ></textarea>
              ) : (
                <div className="loading-container">
                  <SyncLoader
                    color={color}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                  <h1 style={{ color: color }}>Translating...</h1>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
